import { BaggageClaim, Bluetooth, CalendarPlus, Pencil } from "lucide-react";
import React from "react";

const HERO_IMG = "/mnt/data/Screenshot 2025-10-04 175825.png";

export default function HeroCard20() {
  return (
    <>
      <section className="atk-hero">

        {/* BACKGROUND */}
        <div className="atk-bg-grid atk-grid-left"></div>
        <div className="atk-bg-grid atk-grid-right"></div>
        <div className="atk-breath-light"></div>

        <div className="atk-container">

          {/* LEFT CONTENT */}
          <div className="atk-left fade-slide">
            <div className="atk-badge">TAUGHT BY</div>

            <h1 className="atk-title">
              SHWETABH <br /> GANGWAR
            </h1>

            <p className="atk-subtext">
              Author, Problem Solver, Motivational Speaker,<br />
              Integrating Life Sciences.
            </p>

            {/* SOCIAL BOX */}
            <div className="atk-social-box glow-box">
              <p className="atk-find-text">Find on:</p>

              <div className="atk-social-row">
                <div className="atk-icon-circle">F</div>
                <div className="atk-icon-circle">X</div>
                <div className="atk-icon-circle">I</div>
                <div className="atk-icon-circle">L</div>
                <div className="atk-icon-circle">Y</div>
              </div>
            </div>
       {/* black logos bar */}
        <div className="atk-logos-bar">
          <div className="atk-logos-bar-inner">
            <div className="atk-logos-bar-left">
              <img src={""} alt="mini" className="atk-mini-thumb" />
              <div className="atk-countdown-msg">Hurry Up!! Time is running out.</div>
            </div>

            <div className="atk-logos-bar-right">
              <div className="register-cta">Register Today for Rs. 1500</div>
            </div>
          </div>
        </div>   </div>

          {/* RIGHT IMAGE */}
         

          {/* RIGHT FEATURE LIST */}
          <div className="atk-feature-list fade-slide-right">

            <div className="atk-feature">
              <div className="atk-feature-icon"><Pencil color={"#ffffff"} size={20}/></div>
              <div className="atk-feature-text">
                <span>Bestselling Author</span> The Rudest Book Ever
              </div>
              <span className="atk-number">01</span>
            </div>

            <div className="atk-feature">
              <div className="atk-feature-icon"><BaggageClaim color={"#ffffff"} size={20}/></div>
              <div className="atk-feature-text">
                <span>Problem Solver</span> & Speaker
              </div>
              <span className="atk-number">02</span>
            </div>

            <div className="atk-feature">
              <div className="atk-feature-icon"><CalendarPlus color={"#ffffff"} size={20}/></div>
              <div className="atk-feature-text">
                <span>Philosophy & Psychology</span> Lecturer
              </div>
              <span className="atk-number">03</span>
            </div>

            <div className="atk-feature">
              <div className="atk-feature-icon"><Bluetooth color={"#ffffff"} size={20}/></div>
              <div className="atk-feature-text">
                <span>Practical</span> Life Advice
              </div>
              <span className="atk-number">04</span>
            </div>
   
          </div>
       </div>
      </section>

      <style>{`
/* --------------------------------------------------------
   BASE HERO WRAPPER
-------------------------------------------------------- */
.atk-hero {
  position: relative;
 
  background: #0a0a0a;
  overflow: hidden;
  padding: 80px 6%;
  display: flex;
  align-items: center;
}

/* --------------------------------------------------------
   BACKGROUND RED DOT GRIDS
-------------------------------------------------------- */
.atk-bg-grid {
  position: absolute;
  top: 0;
  width: 180px;
  height: 100%;
  background-image: radial-gradient(#ff2e2e 1px, transparent 1px);
  background-size: 10px 10px;
  opacity: 0.18;
  animation: gridFade 4s infinite alternate ease-in-out;
}
/* ------------------- BLACK LOGO BAR ------------------- */
.atk-logos-bar {
  background: #0a0a0a;
  border-top: 1px solid rgba(255,255,255,0.02);
  padding: 18px 6%;
}
.atk-logos-bar-inner {
  max-width: 1400px;
  margin:0 auto;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap: 12px;
}

/* left small thumb + message */
.atk-logos-bar-left {
  display:flex; align-items:center; gap: 14px;
}
.atk-mini-thumb {
  width:56px; height:56px; object-fit:cover; border-radius:6px; box-shadow: 0 8px 20px rgba(0,0,0,0.6);
}
.atk-countdown-msg { color:#fff; opacity:0.9; font-weight:600; }

/* right CTA */
.atk-logos-bar-right .register-cta {
  background: linear-gradient(90deg,#8d1e1e,#b32b2b);
  color: #fff;
  padding: 14px 26px;
  border-radius: 32px;
  font-weight: 800;
  box-shadow: 0 12px 30px rgba(179,43,43,0.22);
}
.atk-grid-left { left: 0; }
.atk-grid-right { right: 0; }

@keyframes gridFade {
  0% { opacity: 0.15; }
  100% { opacity: 0.30; }
}

/* --------------------------------------------------------
   BREATHING RED LIGHT EFFECT
-------------------------------------------------------- */
.atk-breath-light {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 60% 40%, rgba(255,30,30,0.2), transparent 60%);
  mix-blend-mode: screen;
  opacity: 0.4;
  animation: breath 6s ease-in-out infinite;
}

@keyframes breath {
  0% { opacity: 0.25; }
  50% { opacity: 0.55; }
  100% { opacity: 0.25; }
}

/* --------------------------------------------------------
   CONTAINER
-------------------------------------------------------- */
.atk-container {
  max-width: 1600px;
  margin: auto;
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

/* --------------------------------------------------------
   LEFT SECTION
-------------------------------------------------------- */
.atk-left {
  max-width: 550px;
}

.atk-badge {
  background: #751d1d;
  color: #fff;
  padding: 8px 18px;
  border-radius: 6px;
  font-size: 0.9rem;
  letter-spacing: 1px;
  display: inline-block;
  animation: pulseBadge 2.4s infinite;
}

@keyframes pulseBadge {
  0% { background:#751d1d; }
  50% { background:#9a2b2b; }
  100% { background:#751d1d; }
}

.atk-title {
  font-size: 3.8rem;
  font-weight: 800;
  margin: 20px 0;
  color: #fff;
  line-height: 1.1;
}

.atk-subtext {
  color: #e6e6e6;
  margin-bottom: 40px;
  font-size: 1.1rem;
  line-height: 1.6;
}

/* --------------------------------------------------------
   SOCIAL BOX
-------------------------------------------------------- */
.atk-social-box {
  border: 1px solid #ff3b3b;
  border-radius: 10px;
  padding: 22px 24px;
  width: fit-content;
  backdrop-filter: blur(4px);
  background: rgba(255,0,0,0.05);
}

.glow-box {
  animation: glowPulse 3s infinite ease-in-out;
}

@keyframes glowPulse {
  0% { box-shadow: 0 0 10px rgba(255,60,60,0.2); }
  50% { box-shadow: 0 0 22px rgba(255,60,60,0.45); }
  100% { box-shadow: 0 0 10px rgba(255,60,60,0.2); }
}

.atk-find-text {
  font-size: 0.9rem;
  color: #fff;
  margin-bottom: 10px;
}

.atk-social-row {
  display: flex;
  gap: 14px;
}

.atk-icon-circle {
  width: 38px;
  height: 38px;
  background: #1d1d1d;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  border: 1px solid #ff3b3b;
  font-size: 0.9rem;
}

/* --------------------------------------------------------
   RIGHT IMAGE
-------------------------------------------------------- */
.atk-right {
  position: relative;
  z-index: 20;
}

.atk-img {
  width: 420px;
  filter: brightness(0.95);
}

/* --------------------------------------------------------
   RIGHT FEATURE LIST
-------------------------------------------------------- */
.atk-feature-list {
  position: absolute;
  right: 6%;
  top: 20%;
  transform: translateY(-50%);
  width: 360px;
}

.atk-feature {
  display: flex;
  align-items: center;
  background: rgba(40,10,10,0.35);
  border: 1px solid rgba(255,60,60,0.25);
  padding: 18px 18px;
  margin-bottom: 18px;
  border-radius: 8px;
  backdrop-filter: blur(4px);
  position: relative;
}

.atk-feature-icon {
  background: #8c1d1d;
  width: 46px;
  height: 46px;
  border-radius: 10px;
  display:flex;
  justify-content:center;
  align-items:center;
  margin-right: 16px;
  color: #fff;
  font-size: 1.1rem;
}

.atk-feature-text span {
  color: #ff3b3b;
  font-weight: 700;
}

.atk-number {
  position: absolute;
  right: 16px;
  top: 16px;
  color: #ff3b3b;
  opacity: 0.7;
}

/* --------------------------------------------------------
   ANIMATIONS
-------------------------------------------------------- */
.fade-in {
  animation: fadeIn 1.3s ease forwards;
}
@keyframes fadeIn {
  from { opacity:0; transform:translateY(20px); }
  to   { opacity:1; transform:translateY(0); }
}

.fade-slide {
  animation: fadeSlideLeft 1.3s ease forwards;
}
@keyframes fadeSlideLeft {
  from { opacity:0; transform:translateX(-40px); }
  to   { opacity:1; transform:translateX(0); }
}

.fade-slide-right {
  animation: fadeSlideRight 1.3s ease forwards 0.4s;
}

@keyframes fadeSlideRight {
  from { opacity:0; transform:translateX(40px); }
  to   { opacity:1; transform:translateX(0); }
}

/* --------------------------------------------------------
   RESPONSIVE
-------------------------------------------------------- */
@media (max-width: 1050px) {
  .atk-container {
    flex-direction: column;
    text-align:center;
    gap:40px;
  }
  .atk-feature-list {
    position: relative;
    right:unset;
    transform:none;
    margin-top:40px;
  }
}
      `}</style>
    </>
  );
}
